import { render, staticRenderFns } from "./StarredProjectsBlankSlate.vue?vue&type=template&id=42d945fe&"
import script from "./StarredProjectsBlankSlate.vue?vue&type=script&lang=js&"
export * from "./StarredProjectsBlankSlate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports